"use client";

import { Fragment, useEffect, useState } from "react";
import { CircularProgress, TextField } from "@mui/material";

import { SearchResult } from "@/types/helpDesk";

import { useSearch } from "@/context/helpDesk/search";

import { ExtendedTable } from "@/components/wrapper/extendedTable";

import columns from "@/app/help-desk/search/columns";

export default function Search() {
  const [search, setSearch] = useState("");
  const [focus, setFocus] = useState(false);
  const [showSpinner, setShowSpinner] = useState<boolean>(false);

  const { getUserSearchResults, handleRowClick, searchResults } = useSearch();

  useEffect(() => {
    const handler = setTimeout(async () => {
      if (search.trim().length > 2) {
        setShowSpinner(true);
        await getUserSearchResults(search);
        setShowSpinner(false);
      }
    }, 1000); // 1 second

    return () => {
      clearTimeout(handler);
    };
  }, [search]);

  const searchFocus = () => {
    setFocus(!focus);
  };

  return (
    <>
      <TextField
        color="success"
        id="outlined-search"
        label="User Search"
        fullWidth
        onChange={(event) => setSearch(event.target.value)}
        variant="standard"
        className="search"
        slotProps={{
          htmlInput: {
            coloroverride: "white",
            placeholder: "Username, Name, or N#",
          },
          inputLabel: {
            htmlFor: "search-input",
            id: "search-input-label",
            className:
              !focus && !search.trim().length
                ? "searchLabelText"
                : "searchLabelTextFocus",
          },
          input: {
            "aria-labelledby": "search-input-label",
            color: "secondary",
            className: "searchText",
            id: "search-input",
            onFocus: searchFocus,
            onBlur: searchFocus,
            endAdornment: (
              <Fragment>
                {showSpinner ? (
                  <CircularProgress
                    color="success"
                    size={36}
                    coloroverride="white"
                  />
                ) : null}
              </Fragment>
            ),
          },
        }}
        sx={{ marginTop: !searchResults.length ? "25%" : "auto" }}
        autoFocus
        value={search}
        placeholder="Username, Name, or N#"
      />
      <ExtendedTable<SearchResult>
        columns={columns}
        onRowClick={handleRowClick}
        rows={searchResults}
        orderBy={"username"}
      />
    </>
  );
}
